import { render, staticRenderFns } from "./NuevaTransferencia.vue?vue&type=template&id=78bfbc74&scoped=true"
import script from "./NuevaTransferencia.vue?vue&type=script&lang=js"
export * from "./NuevaTransferencia.vue?vue&type=script&lang=js"
import style0 from "./NuevaTransferencia.vue?vue&type=style&index=0&id=78bfbc74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bfbc74",
  null
  
)

export default component.exports